// extracted by mini-css-extract-plugin
export var item = "language-item-module--item--n-4DO";
export var itemActive = "language-item-module--item-active--v4okk";